import React from 'react';
import {Dropdown} from 'semantic-ui-react';

import BasicModal from "components/common/BasicModal";
import {isNoU} from "utils/DBUtils";
import {basicForm} from "utils/helpers";
import ErrorDisplay from "components/common/ErrorDisplay";
import config from './addHomepageItemFormConfig';

const AddHomepageItemForm = basicForm(config);

const AddItemModal = (props) => (
    <BasicModal header="Add Item"
                specialType="primary-modal fadeInUp animResponse"
                dimmer={'inverted'}
                modalSize="small"
                actions={[
                    {
                        label: "Cancel",
                        action: props.handleClose,
                        isDisabled: false,
                        displayType: "menu-item"
                    },
                    {
                        label: "Add",
                        action: props.submit,
                        isDisabled: !isNoU(props.errors) && Object.keys(props.errors).length > 0,
                        displayType: "button",
                        primaryCheck: true
                    }
                ]}
                open={props.modalOpen}
                onClose={props.handleClose}>
        <div>
          <AddHomepageItemForm onValueChanged={props.onValueChanged}
                         onValidationError={props.onValidationError}
                         errors={props.errors}
                         data={props.formData}/>
        </div>

        <ErrorDisplay error={props.creationError}/>
    </BasicModal>
);

export default AddItemModal;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/AddItemModal/AddItemModal.jsx